import React, { Suspense } from "react";
import {
  Box,
  Typography,
  Button,
  SvgIcon,
  Card,
  CardContent,
  CardActions,
} from "@mui/material";
import Loader from "../../../_default/Loader";

const LazyCardMedia = React.lazy(() => import("../../../_default/LazyCardMedia"));

// Common Button Component
const ActionButton = ({ href, text }) => (
  <Button
    variant="contained"
    color="primary"
    href={href}
    endIcon={
      <SvgIcon
        width="16"
        height="14"
        viewBox="0 0 16 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1 7L15 7M15 7L9 1M15 7L9 13"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </SvgIcon>
    }
  >
    {text}
  </Button>
);

// Data array for cards
const data = [
  {
    imgSrc: "/img/teacher.png",
    title: "Become an Instructor",
    description:
      "To take a trivial example, which of us undertakes physical exercise yes is this happen here.",
    href: "/contact",
  },
  {
    imgSrc: "/img/student.png",
    title: "Become a Student",
    description:
      "Join millions of people from around the world learning together. Online learning",
    href: "/contact",
  },
];



// Dynamic content rendering using Suspense
const renderContent = (item, index) => (
  <Suspense fallback={<Loader />} key={index}>
    <LazyCardMedia
      imgSrc={item.imgSrc}
      altText={`${item.title} - ${index + 1}`}
    />
  </Suspense>
);

const ApplySection = () => (
  <Box sx={{ py: 4 }}>
    <Box
      display="flex"
      flexDirection={{ lg: "row", md: "column", sm: "column", xs: "column" }}
      gap={4}
      justifyContent="center"
      alignItems="stretch" // Ensures all boxes stretch to the same height
    >
      {data.map((item, index) => (
        <Box key={index} flex="1" display="flex" flexDirection="column">
          <Card sx={{ p: 2, height: "100%" }}>
            <Box
              display="flex"
              flexDirection={{ xs: "column", sm: "row" }}
              height="100%"
            >
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                flex="1"
                
              >
                {renderContent(item, index)}
              </Box>
              <Box flex="1" p={2}>
                <CardContent sx={{ flexGrow: 1 }}>
                  <Typography variant="h6" component="h3">
                    <a
                      href={item.href}
                      style={{ textDecoration: "none", color: "inherit" }}
                    >
                      {item.title}
                    </a>
                  </Typography>
                  <Typography variant="body2" sx={{ mb: 2 }}>
                    {item.description}
                  </Typography>
                  <CardActions>
                    <ActionButton href={item.href} text="Apply Now" />
                  </CardActions>
                </CardContent>
              </Box>
            </Box>
          </Card>
        </Box>
      ))}
    </Box>
  </Box>
);

export default ApplySection;
